import { createBasicSelector } from 'util/redux'
import { selectCurrentQuery } from './selectCurrentQuery'

export const selectCurrentFolderId = createBasicSelector(
  selectCurrentQuery,
  query => query.folder
)
